import axios from 'axios'

const api = axios.create({
  baseURL: 'https://rest-api.apvixai.com/',
  headers: { 'Content-Type': 'application/json' },
});

// // Attach JWT token and selected branch to every request
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('access_token')
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`
//   }
//   // Auto-attach selected branch for data-fetching requests
//   const branch = localStorage.getItem('selected_branch')
//   if (branch && config.method === 'get') {
//     config.params = config.params || {}
//     if (!config.params.branch_id) {
//       config.params.branch_id = branch
//     }
//   }
//   return config
// })

// // Handle 401 responses
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('access_token')
//       localStorage.removeItem('refresh_token')
//       localStorage.removeItem('user')
//       if (window.location.pathname !== '/login') {
//         window.location.href = '/login'
//       }
//     }
//     return Promise.reject(error)
//   }
// )

export default api
